import { GetFeatureUsagesResponseUsageFeature } from '@modusign/openapi-client-subscription/model';

export type FeatureType = GetFeatureUsagesResponseUsageFeature;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureType = GetFeatureUsagesResponseUsageFeature;
